<template>
    <div class="indexbox">
        <wallet-head show_type="3" />

        <div-height height="3vw"></div-height>

        <!-- 折线 -->
        <div class="zhexian">
            <div id="myChart" ref="myChart" style="width: 92vw; height: 70vw"></div>
        </div>

        <div-height height="10vw" />

        <div class="add_box">

            <div-height height="10vw" />

            <div class="border">
                <div class="icon">
                    <img src="@/assets/img/c01.png">
                </div>
                <div class="text">
                    {{ $t('成交量') }}：{{ order_amount }}
                </div>
            </div>
            <div-height height="10vw" />
            <div class="border">
                <div class="icon">
                    <img src="@/assets/img/c02.png">
                </div>
                <div class="text">
                    {{ $t('矿工数') }}：{{ power_count }}
                </div>
            </div>

        </div>

        <div-height height="3vw"></div-height>

    </div>
</template>
<script>
import { deposit } from "@/utils/index.js"
import * as echarts from "echarts"
import Web3 from "web3"
export default {
    data() {
        return {
            list: [],
            order_amount: "0.00",
            power_count: "0.00",
        }
    },
    created() {
        this.get_data();
        this.drawLine();
    },
    methods: {
        get_data() {
            this.$get({
                url: "/api/v1/member/getStatistics",
                success: (res) => {
                    this.order_amount = res.data.order_amount * 1;
                    this.power_count = res.data.power_count * 1;
                },
                fail: () => { },
            });
        },

        drawLine() {
            this.$get({
                url: "/api/v1/priceLog/getPriceLog",
                success: (res) => {
                    setTimeout(function () {
                        let chart_data = {
                            price_time: res.data.map(item => item.date),
                            price_val: res.data.map(item => item.price),
                        };

                        let myChart = echarts.init(document.getElementById("myChart"));
                        setTimeout(function () {
                            window.onresize = function () {
                                myChart.resize();
                            };
                        }, 200);
                        // 绘制图表 backgroundColor: "#6a7985"
                        myChart.setOption({
                            // tooltip: {
                            //   trigger: "axis",
                            //   axisPointer: {
                            //     type: "shadow",
                            //     label: {
                            //       backgroundColor: "#6a7985",
                            //     },
                            //   },
                            // },
                            xAxis: {
                                type: "category",
                                splitLine: {
                                    show: false,
                                },
                                //轴线不显示
                                axisLine: {
                                    show: false,
                                    //  改变轴线颜色
                                    lineStyle: {
                                        // 使用深浅的间隔色
                                        color: "transparent",
                                    },
                                },
                                //网格样式

                                data: chart_data.price_time,
                                axisLabel: {
                                    //底部时间颜色
                                    textStyle: {
                                        color: "#fff",
                                        fontSize: "10",
                                    },
                                },
                            },
                            grid: {
                                top: "10%",
                                left: "10%",
                                right: "10%",
                                bottom: "10%",
                                //  containLabel: true,
                            },
                            yAxis: [
                                {
                                    type: "value",
                                    nameLocation: "end",
                                    //轴线不显示
                                    // color: "transparent",
                                },
                                {
                                    type: "value",
                                    color: "#fff",
                                    position: "left", // 👈 关键：强制将第二个 Y 轴放在左侧
                                    axisLine: {
                                        show: false,
                                        // color: "transparent",
                                        //  改变轴线颜色
                                    },
                                    axisLabel: {
                                        //右侧文字颜色
                                        textStyle: {
                                            color: "#fff",
                                        },
                                    },
                                    splitLine: {
                                        show: true,
                                        lineStyle: {
                                            color: '#000',     // ← 修改横线颜色（可以是字符串或数组）
                                            width: 1,
                                        }
                                    },
                                }
                            ],
                            series: [
                                {
                                    data: chart_data.price_val,
                                    type: "line",
                                    name: "价格",
                                    yAxisIndex: 1,
                                    smooth: true,

                                    showSymbol: true, //是否默认展示圆点
                                    symbol: "circle", //设定为实心点
                                    symbolSize: 12, //设定实心点的大小

                                    itemStyle: {
                                        color: "rgba(148, 255, 233, 1)",
                                        width: 0.8,
                                    },
                                    label: {
                                        normal: {
                                            color: "rgba(148, 255, 233, 1)",
                                            show: true,
                                        },
                                        formatter: "{@value}",
                                    }, areaStyle: {
                                        color: {
                                            type: "linear",
                                            x: 0, //右
                                            y: 0, //下
                                            x2: 0, //左
                                            y2: 1, //上
                                            colorStops: [
                                                {
                                                    offset: 0,
                                                    color: "rgba(148, 255, 233, 0.5)", // 0% 处的颜色
                                                },
                                                {
                                                    offset: 1,
                                                    color: "rgba(148, 255, 233, 0)", // 100% 处的颜色
                                                },
                                            ],
                                        },
                                    },
                                },
                            ],
                        });
                    }, 200);

                },
                tip: (val) => { },
            });
        },




    },
}
</script>
<style lang="less" scoped>
.indexbox {
    width: 100%;


    .new_box {
        margin: 0 auto;
        width: 94vw;
        padding: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid rgba(32, 197, 149, 1);
        border-radius: 2vw;
        background: #272c52;
        padding: 1vw 3vw;

        img {
            width: 6vw;
            height: 6vw;

            &:nth-child(3) {
                width: 15px;
                height: 15px;
            }
        }

        .gogngao_img {
            height: 8vw;
            display: flex;
            align-items: center;

            img {
                width: 15px;
                height: 15px;
            }
        }

        .swipe {
            flex: 1;
            height: 8vw;

            .van-swipe-item {
                width: 100%;
                height: 8vw;
                padding: 0 12px;

                >p {
                    width: 100%;
                    line-height: 8vw;
                    font-size: 14px;
                    font-weight: 550;
                }
            }
        }
    }


    .add_box {
        width: 90vw;
        height: 69vw;
        border-radius: 3vw;
        background: url("~@/assets/img/kuang.png") no-repeat;
        margin: 0 auto;
        background-size: 100%;
        background-position: center;
        padding: 7vw;

        .label {
            font-size: 4vw;
            color: #fff;
            padding: 2vw 0;
        }

        .border {
            display: flex;
            color: #fff;
            padding: 1.5vw;
            border: 1px solid #20c595;
            border-radius: 2vw;
            justify-content: flex-start;
            align-items: center;

            .icon {
                width: 10vw;
                height: 10vw;
                margin-right: 3vw;

                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                }
            }

            .text {
                font-size: 4vw;
            }
        }
    }


    .htmlcontent {
        width: 90vw;
        background: #272c52;
        padding: 3vw;
        margin: 0 auto;
        border-radius: 2vw;
    }

    .card {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 4vw;

        .cards1 {
            width: 45vw;
            height: 26vw;
            border-radius: 3vw;
            background: url("~@/assets/img/lunpan.gif") no-repeat;

            background-size: 30vw 30vw;
            background-position: center;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .p1 {
                font-size: 3.5vw;
                color: #fff;
                margin-bottom: 1vw;
                text-align: center;
            }

            .p2 {
                font-size: 4vw;
                color: #fff;
                font-weight: 550;
                text-align: center;
            }
        }

        .cards2 {
            width: 60vw;
            height: 40vw;
            border-radius: 3vw;
            background: url("~@/assets/img/lunpan.gif") no-repeat;

            background-size: 35vw 35vw;
            background-position: center;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .p1 {
                font-size: 3.5vw;
                color: #fff;
                margin-bottom: 1vw;
                text-align: center;
            }

            .p2 {
                font-size: 4vw;
                color: #fff;
                font-weight: 550;
                text-align: center;
            }
        }

        .cards3 {
            width: 45vw;
            height: 26vw;
            border-radius: 3vw;
            background: url("~@/assets/img/lunpan.gif") no-repeat;

            background-size: 30vw 30vw;
            background-position: center;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .p1 {
                font-size: 3.5vw;
                color: #fff;
                margin-bottom: 1vw;
                text-align: center;
            }

            .p2 {
                font-size: 4vw;
                color: #fff;
                font-weight: 550;
                text-align: center;
            }
        }
    }

    .cared_img {
        width: 92vw;
        height: 19vw;
        margin: 0 auto;

        background-size: 100% auto;
        padding: 9vw 0 0 32vw;

        p {
            font-size: 4vw;
            color: #fff;

            span {
                font-size: 5vw;
                font-weight: 550;
                color: #ceb082;
            }
        }
    }

    .id_title {
        padding: 4vw 4vw 0 4vw;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
                width: 4vw;
                height: 4vw;
                margin-right: 1vw;
            }

            .name {
                font-size: 5vw;
                color: #fff;
                font-weight: 550;
            }
        }

        .right {
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 4vw;
            color: #ceb082;
        }
    }

    .ebox {
        width: 100%;
        height: 250px;
    }


    .bodybox {
        width: 100%;
        padding: 0 15px 50px;

        .mens {
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            >div {
                width: 168px;
                background: #242424;
                border-radius: 6px;
                margin-bottom: 10px;
                padding: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .num {
                    width: 77%;

                    p {
                        color: #999999;
                        font-size: 12px;

                        &:nth-child(2) {
                            color: #fea427;
                            font-size: 16px;
                            font-weight: 550;

                            span {
                                font-size: 12px;
                            }
                        }
                    }
                }

                img {
                    width: 30px;
                    height: 30px;
                }
            }
        }

        .invest {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #242424;
            border-radius: 6px;
            padding: 10px;

            img {
                width: 70px;
                height: 70px;
            }

            .info {
                width: 50%;
                font-size: 12px;

                p {
                    &:nth-child(1) {
                        font-size: 16px;
                        font-weight: 550;
                        margin-bottom: 10px;
                    }
                }
            }

            .btn {
                width: 25%;
                height: 70px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;

                p {
                    color: #fea427;
                    font-size: 12px;

                    span {
                        margin-left: 5px;
                    }
                }

                /deep/.van-button {
                    padding: 3px 8px;

                    .van-button__text {
                        color: #fff;
                        font-size: 12px;
                    }
                }
            }
        }

        .tit {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 20px 0;

            span {
                width: 2px;
                height: 15px;
                background: #fea427;
                margin-right: 7px;
            }

            font-size: 16px;
            font-weight: 550;
        }

        .list {
            width: 100%;
            background: #242424;
            border-radius: 6px;
            padding: 10px 15px;
            margin-bottom: 20px;

            .top {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;

                >div {
                    color: #999999;
                    font-size: 12px;

                    p {
                        &:nth-child(2) {
                            font-weight: 550;
                            font-size: 16px;
                            color: #fff;
                            margin-top: 5px;
                        }
                    }
                }

                span {
                    background: rgba(255, 236, 209, 0.1);
                    border-radius: 6px;
                    padding: 3px 10px;
                    color: #8bff36;
                    font-size: 12px;
                    font-weight: 550;
                }
            }

            .num {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                >div {
                    color: #fea427;
                    font-size: 16px;
                    font-weight: 550;
                    max-width: 33%;

                    p {
                        color: #999999;
                        font-size: 12px;

                        &:nth-child(2) {
                            margin-top: 5px;
                            color: #fea427;
                            font-size: 16px;
                            font-weight: 550;

                            span {
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }

        .more {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 2px 0 20px;

            span {
                font-size: 16px;
                font-weight: 550;
            }

            img {
                width: 12px;
                height: 12px;
                object-fit: contain;
            }
        }
    }
}

.popupcode {
    background: #242424;
    box-shadow: 0px 3px 10px 1px rgba(255, 236, 209, 0.13);

    .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;

        >p {
            width: 100%;
            text-align: center;
            font-size: 15px;
            font-weight: 550;
            padding: 5px 0 30px;
        }

        /deep/.van-cell {
            background: #0f0f0f;
            border-radius: 6px;
            margin-bottom: 15px;

            .van-cell__title {
                width: 4em;
                color: #fff;
            }

            .van-field__control {
                color: #fff;
            }
        }

        .van-button {
            margin-top: 15px;
        }
    }
}

.popupbox {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: none;

    .content {
        width: 100%;
        background: #242424;
        box-shadow: 0px 3px 10px 1px rgba(255, 236, 209, 0.13);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;

        >p {
            width: 100%;
            text-align: center;
            font-size: 15px;
            font-weight: 550;
            padding: 5px 0 30px;
        }

        /deep/.van-cell {
            background: #0f0f0f;
            border-radius: 6px;
            margin-bottom: 15px;

            .van-cell__title {
                width: 4em;
                color: #fff;
            }

            .van-field__control {
                color: #fff;
            }
        }

        /deep/.van-button {
            margin-top: 15px;
        }

        .e {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            font-size: 12px;
            color: #fea427;
            padding: 0 0 10px;
            font-weight: 500;

            span {
                max-width: 49%;

                &:nth-child(1) {
                    text-align: right;
                }

                &:nth-child(2) {
                    text-align: right;
                }
            }
        }
    }

    .close {
        width: 40px;
        height: 40px;
        margin-top: 30px;
    }
}

//折线图
.zhexian {

    background-size: 100% 100%;
    margin: 0 auto;
    overflow: hidden;
    // background: #333;
    border-radius: 4vw;
    overflow: auto;
    width: 92vw;
    height: 70vw;
    box-sizing: border-box;
    // padding: 10px auto;
    text-align: center;
}
</style>